import cookieSolution from './cookie-solution';
import { isConfigAvailable } from './config';

if (isConfigAvailable()) {
    const modCookieSolution = new cookieSolution();
    modCookieSolution.init();
}
